import { AxiosError } from 'axios';
import { PUT_NOTIFICATION_ACKNOWLEDGEMENT_STATUS_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutNotificationAcknowledgementStatus = ({ onSuccess, onError, uuid }: Input) => {
  const putNotificationAcknowledgementStatus = async () => {
    const res = await axiosClient.put<void>(PUT_NOTIFICATION_ACKNOWLEDGEMENT_STATUS_URL(uuid));
    return res.data;
  };

  return useCustomMutation(putNotificationAcknowledgementStatus, {
    onSuccess,
    onError,
  });
};
